import { useState } from 'react';
import classes from './CopyableText.module.css';
import { Text, TextProps, Tooltip } from '@mantine/core';

export const CopyableText = ({
  value,
  copyableValue,
  color,
  rightSection,
  size,
}: {
  value: string;
  copyableValue?: string;
  color?: TextProps['c'];
  rightSection?: React.ReactNode;
  size?: TextProps['size'];
}) => {
  const [isCopied, setIsCopied] = useState(false);
  const textElement = () => {
    return (
      <Text
        className={!!copyableValue ? classes.copyable : ''}
        size={size ?? 'sm'}
        c={color ?? 'inherit'}
        onClick={() => {
          if (!copyableValue) return;
          navigator.clipboard.writeText(copyableValue);
          setIsCopied(true);
          setTimeout(() => setIsCopied(false), 3000);
        }}
      >
        {value}
      </Text>
    );
  };
  return (
    <div className={classes.staticField}>
      {copyableValue ? (
        <Tooltip
          label={
            isCopied ? `Copied '${copyableValue}'` : `Copy '${copyableValue}'`
          }
        >
          {textElement()}
        </Tooltip>
      ) : (
        textElement()
      )}
      {rightSection}
    </div>
  );
};
